import { ActionTypes } from "../../Actions/ActionTypes"
import api from "../../seller-apis/api";
let initialState = {
  ordersCount: {
    "grabOrders":0,
    "ProductOpportunities":0,
    "newOrders":0,
    "Redispatch":0,
    "reverseOrder":0,
    "readyToShipped":0,
    "shipped":0,
    "all":0,
    // Sl-967
    "revoked":0
  },
  RTOCount: null,
  inventoryCount: null,
  priceVericationMenu: true,
  QCRequestSent: false,
  verifiedSeller: true,
  sellerCount: null,
  activeProduct: null,
  PendingQuestionCount: null,
  WalletAmount: 0,
  LeadChatCount: 0,
  LeadCont: 0,
  TotalLeadCount: 0,
  opportunityCount: 0,
  ShowHideMenu: false,
  opportunityOutOfStockCount: 0,
  grabOrderCount: 0, //SL-660 Grab Order
  leadSubscription: null, //SL-710 Seller Leads
  pendingNoticeCount: 0, //SL-741 Grab Order
  grabOrderPopupState: {
    visible: false,
    data: {},
    disableTimer: false,
  }, // SL-890
  addresses: {
    data:[]
  }, //SL-923 Pickup Address
  notificationCount: 0 , // SL-768-PROD
  vendorFrozenCheckResponse: null,
  orderCountsBulkFetchCompleted: false,
  productCountsBulkFetchCompleted: false,
  productOpportunityCount:0,
  recommendedProductOpportunityCount:0

};
const ActionsReducers = (state = initialState, action) => {
  //   console.log(action);
  switch (action.type) {
    case ActionTypes.VENDOR_FROZEN_CHECK_SUCCESS:
      return {
        ...state,
        vendorFrozenCheckResponse: action.payload,
      };
    case ActionTypes.VENDOR_FROZEN_CHECK_RESET:
      return {
        ...state,
        vendorFrozenCheckResponse: null,
      };
    case "ORDER_COUNT":
      return {
        ...state,
        ordersCount: {
          ...state.ordersCount,
          ...action.payload
        }
      };
    case ActionTypes.ORDER_COUNTS_BULK_FETCH_COMPLETE:
      return {
        ...state,
        orderCountsBulkFetchCompleted: true,
      };
    case ActionTypes.ORDER_COUNTS_BULK_FETCH_RESET:
      return {
        ...state,
        orderCountsBulkFetchCompleted: false,
      };
    case ActionTypes.PRODUCT_COUNTS_BULK_FETCH_COMPLETE:
      return {
        ...state,
        productCountsBulkFetchCompleted: true,
      };
    case ActionTypes.PRODUCT_COUNTS_BULK_FETCH_RESET:
      return {
        ...state,
        productCountsBulkFetchCompleted: false,
      };
    case "RTO_ORDER_COUNT":
      return {
        ...state,
        RTOCount: action.payload,
      };
    case "INVENTORY_COUNT":
      return {
        ...state,
        inventoryCount: action.payload,
      };
    case "INVENTORY_COUNT_UPDATE":
      return {
        ...state,
        inventoryCount: {
          ...(state.inventoryCount || {}),
          ...action.payload,
        },
      };
    case ActionTypes.ACTIVE_PRODUCT_COUNT:
      console.log('action.payload', action.payload)
      return {
        ...state,
        activeProduct: action.payload,
      };
    case "PRICE_VERIFICATION_PENDING_MENU":
      return {
        ...state,
        priceVericationMenu: action.payload,
      };
    case ActionTypes.QC_REQUEST_SEND:
      return {
        ...state,
        QCRequestSent: action.payload,
      };
    case ActionTypes.VERIFIED_SELLER:
      return {
        ...state,
        verifiedSeller: action.payload,
      };
    case ActionTypes.UPDATE_SELLER_MESSAGE_COUNT:

      return {
        ...state,
        sellerCount: action.payload,
      };

    case ActionTypes.PRODUCT_ACTION_REQUIRED_COUNT:

      return {
        ...state,
        pActionRequiredCount: action.payload,
      };
    case ActionTypes.BLOCKED_STATUS:

      return {
        ...state,
        vendorBlockedStatus: action.payload,
      };
    case ActionTypes.UPADTE_QUESTION_COUNT:
      return {
        ...state,
        PendingQuestionCount: action.payload,
      };
    case ActionTypes.WALLET_AMOUNT:
      return {
        ...state,
        WalletAmount: action.payload,
      };
    case ActionTypes.LEAD_CHAT_COUNT:
      return {
        ...state,
        LeadChatCount: action.payload,
      };
    case ActionTypes.LEAD_COUNT:
      return {
        ...state,
        LeadCount: action.payload,
      };
    case ActionTypes.TOTAL_LEAD_COUNT:
      return {
        ...state,
        TotalLeadCount: action.payload,
      };
    case "OPPORTUNITY_COUNT":
      return {
        ...state,
        opportunityCount: action.payload,
      };
    case "OPPORTUNITY_OUT_OF_STOCK_COUNT":
      return {
        ...state,
        opportunityOutOfStockCount: action.payload,
      };
    case ActionTypes.SHOW_HIDE_MENU:
      return {
        ...state,
        ShowHideMenu: action.payload,
      };
    case "GRAB_ORDER_COUNT"://SL-660
      return {
         ...state,
         grabOrderCount: action.payload,
      }; 
    case ActionTypes.LEAD_SUBSCRIPTION://SL-710
      return {
         ...state,
         leadSubscription: action.payload,
      };
    case "PENDING_NOTICE_COUNT":
      return {
         ...state,
         pendingNoticeCount: action.payload,
      };  
    case "UPDATE_NOTICE_COUNT":
      return {
         ...state,
         pendingNoticeCount: action.payload,
      };

    // SL-890
    case ActionTypes.GRAB_ORDER_POPUP:
      return {
        ...state,
        grabOrderPopupState: {
          ...state.grabOrderPopupState,
          visible: action.payload?.visible,
          data: action.payload?.data,
          disableTimer: !!action.payload?.disableTimer,
        },
      }; 
    //SL-923
    case ActionTypes.SELLER_ADDRESS:
      return {
         ...state,
         addresses: action.payload,
      }; 
    case ActionTypes.NOTIFICATION_COUNT:
      return {
          ...state,
          notificationCount: action.payload
      };  

    case ActionTypes.BLOCKED_PRODUCTS_COUNT:
      return {
        ...state,
        inventoryCount: action.payload,
      };
    
    case ActionTypes.PRODUCT_OPPORTUNITY_COUNT:
      return {
        ...state,
        productOpportunityCount: action.payload,
      };
    case ActionTypes.RECOMMENDED_PRODUCT_OPPORTUNITY_COUNT:
      return {
        ...state,
        recommendedProductOpportunityCount: action.payload,
      };
      
    default:
      // console.log(state);
      return state;
  }
};
export default ActionsReducers;
